import Vue from 'vue'
import Router from 'vue-router'
import vbclass from 'vue-body-class'
import store from './components/store/store'
import App from './App.vue'
import Vuex from 'vuex'
import './registerServiceWorker'
import { gif } from 'gif.js';
import vuescroll from 'vue-scroll'
import VueLocalStorage from 'vue-localstorage'



//import IdleVue from 'idle-vue'
// import "gif.js/dist/gif.js"
// import "gif.js/dist/gif.worker.js"

import { fabric } from 'fabric';
import UUID from 'vue-uuid';
//import FabricCanvas from './components/MessageCreator/Fabric.vue';
import MessageCreator from './components/MessageCreator'
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueTimers from 'vue-timers'
// import {Vue2Dragula} from 'vue2-dragula'
import Vue2TouchEvents from 'vue2-touch-events'

const VueRouter = new Router({
   mode: 'history',
   routes: [
   {
      path: '/',
      name: 'home',
      meta: {
         bodyClass: 'home',
         scroll: 'no',
         height: '100%',
         style:"overflow: hidden"
      },
   }
   ]
})
// Vue.use(Vue2Dragula, {
//   logging: {
//     service: false
//   }
// });

export default VueRouter
Vue.use( Router );
Vue.use( vbclass, VueRouter );
Vue.use(UUID);
Vue.use(Vuex);
Vue.use(VuejsDialog);
Vue.use(VueTimers);
Vue.use(Vue2TouchEvents);
Vue.use(vuescroll);
Vue.use(VueLocalStorage, {
  name: 'localStorage',
  bind: true //created computed members from your variable declarations
})


Vue.prototype.$eventHub = new Vue(); // Global event bus

//const eventsHub = new Vue()
//Vue.use(IdleVue, {eventEmitter: eventsHub, store, idleTime: 60000 })

/*
 * Extends Fabric Object initialization.
 *
 * Assigns a UUID to every `fabric.Object`: in this way Vue can always
 * recognize the same objects regardless of whence the canvas is being
 * updated.
 *
 * @return void
 */
 const OLD_OBJECT_INIT = fabric.Object.prototype.initialize;

 fabric.Object.prototype.initialize = function() {
   let args = Array.prototype.slice.call(arguments, 0);
   OLD_OBJECT_INIT.apply(this, args);

//  if( !this.get('_uid') )
//    this.set( '_uid', uuid.raw() );
}

/*
 * Extends Fabric Object serialization.
 *
 * Saves the `uid` property during object serialization.
 *
 * @return void
 */
const OLD_OBJECT_TOOBJECT = fabric.Object.prototype.toObject;

fabric.Object.prototype.toObject = function() {
  let args = Array.prototype.slice.call(arguments, 0),
      obj = OLD_OBJECT_TOOBJECT.apply(this, args);

  obj._uid = this._uid;

  return obj;
}



// const VueFabric = {
//   install(Vue, options = {}) {
//     fabric.customEvents = options.customEvents;
//     Vue.prototype.$fabric = fabric;
//
//     Vue.component( 'message-creator', Vue.extend(MessageCreator) );
//   }
// }
//
// export default MessageCreator;

Object.defineProperty(Vue.prototype, '$gif', { value: gif });
//
//
// const OLD_OBJECT_INIT2 = gif.Object.prototype.initialize;
//
// gif.Object.prototype.initialize = function() {
//   let args = Array.prototype.slice.call(arguments, 0);
//   OLD_OBJECT_INIT2.apply(this, args);
//
//   const OLD_OBJECT_TOOBJECT2 = gif.Object.prototype.toObject;
//
//   gif.Object.prototype.toObject = function() {
//     let args = Array.prototype.slice.call(arguments, 0),
//         obj = OLD_OBJECT_TOOBJECT2.apply(this, args);
//
//     obj._uid = this._uid;
//
//     return obj;
//   }
//



Vue.config.productionTip = false

new Vue({
  store,
  VueRouter,
  render: function (h) { return h(App) },
}).$mount('#app')

// debug
//console.log('computed:', App.computed)
console.log('mutations:', store._mutations)
